export const currencyFormat = (amount: string | number, locale: string = 'en-US') => {
  const value: number = ((Number.isNaN(+amount)) ? 0 : +amount);
  return value.toLocaleString(locale, { minimumFractionDigits: 2 });
}
